// pages/AffiliateRedirect.js
// Ce composant capture /r/:code et redirige vers le backend pour le tracking
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../config';

const AffiliateRedirect = () => {
    const { code } = useParams();
    
    useEffect(() => {
        if (code) {
            console.log('🔗 Redirection affilié détectée, code:', code);
            
            // Construire l'URL backend (sans /api à la fin car on veut /r/:code)
            // API_BASE_URL contient déjà /api, donc on doit remonter d'un niveau
            const backendBaseUrl = 'https://rizzingbot.com';
            const redirectUrl = `${backendBaseUrl}/r/${code}`;
            console.log('🔗 Redirection vers backend:', redirectUrl);
            
            // Rediriger vers le backend pour le tracking
            window.location.href = redirectUrl;
        }
    }, [code]);
    
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#1a1a2e',
            color: 'white',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>🚀</div>
                <h2>Redirection en cours...</h2>
                <p style={{ color: '#888' }}>Tu vas être redirigé vers l'inscription</p>
            </div>
        </div>
    );
};

export default AffiliateRedirect;